export default "__VITE_ASSET__3665e026__"